import React, { forwardRef } from "react";
import { createPortal } from "react-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface WeeklyOffBottomButtonsProps extends React.HTMLAttributes<HTMLDivElement> {
  onOpenFullNurse: () => void;
  onSave: () => void;
  isDisabled: boolean;
  isBtnDisabled?: boolean;
}

const WeeklyOffBottomButtons = forwardRef<
  HTMLDivElement,
  WeeklyOffBottomButtonsProps
>(({ onOpenFullNurse, onSave, isDisabled, isBtnDisabled, ...props }, ref) => {
  const buttonContent = (
    <div className="absolute bottom-0 left-0 right-0 z-50 flex justify-center">
      <div
        ref={ref}
        {...props}
        className="w-full p-4 bg-gradient-to-b from-white/20 fixed! bottom-0 to-white/80 backdrop-blur-sm flex gap-3 justify-center items-center before:content-[''] before:absolute before:-top-5 before:left-0 before:w-full before:h-5 before:bg-gradient-to-t before:from-white/80 before:to-transparent "
      >
        {/* 모달이 열렸을 때(주휴설정이 불가할 때) 하단 버튼을 가리는 가림막 */}
        {isDisabled && (
          <div className="absolute inset-0 bg-[#FFFFFFCC] bg-opacity-60 z-[90]"></div>
        )}

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={onOpenFullNurse}
                className={`py-4 px-10 bg-white text-gray-700 font-bold text-[16px] rounded-full border border-gray-300 transition-colors font-pretendard shadow-md ${
                  isBtnDisabled
                    ? "opacity-50 cursor-not-allowed"
                    : "hover:bg-gray-50"
                }`}
                disabled={isBtnDisabled}
              >
                {`전체 간호사 `}
                <span className="text-[#0147a3] text-[16px]">주휴배치</span>
                {" 보기"}
              </button>
            </TooltipTrigger>
            {isBtnDisabled && (
              <TooltipContent sideOffset={5} hidden>
                <p>주휴 설정 저장 후 확인 해주세요</p>
              </TooltipContent>
            )}
          </Tooltip>
        </TooltipProvider>

        <button
          onClick={onSave}
          className="py-4 px-15 bg-[#0259c6] text-white font-bold text-[16px] rounded-full hover:bg-[#0147a3] transition-colors font-pretendard"
        >
          {"저장하기"}
        </button>
      </div>
    </div>
  );

  // Portal 대상이 존재하면 Portal 사용, 아니면 일반 렌더링
  const targetElement = document.querySelector("main");

  return targetElement
    ? createPortal(buttonContent, targetElement)
    : buttonContent;
});

export default WeeklyOffBottomButtons;
